module.exports = __webpack_public_path__ + "static/media/Banner-TelaValores-720x180.14e0de93.png";